/* tslint:disable */
import React from 'react';

import Log from 'providers/log';
import Http from 'services/http';

import { BREAK_POINT } from 'constants/responsive';
import './VideoFeed.sass';
import VideoFeedItem from './VideoFeedItem';

interface IProps {
    className?: string;
    itemClassName?: string;
    playlistId: string;
    displayNum: number;
}

interface IVideo {
    videoId: string;
    videoTitle: string;
    videoDuration: string;
    videoChannel: string;
    videoViews: number;
    videoThumbnailSrc: string;
}

interface IState {
    videos: IVideo[];
}

const api = new Http({ host: process.env.API_URL });

class VideoFeed extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = { videos: [] };
        this.formatVideoDuration = this.formatVideoDuration.bind(this);
    }

    public componentDidMount() {
        const ERROR = 'error';
        const ITEMS = 'items';
        const ID = 'id';
        const VIDEO_ID = 'videoId';
        const SNIPPET = 'snippet';
        const CONTENT_DETAILS = 'contentDetails';
        const STATISTICS = 'statistics';
        const CHANNEL_TITLE = 'channelTitle';
        const THUMB_NAILS = 'thumbnails';
        // const DEFAULT = 'default';
        const URL = 'url';
        const TITLE = 'title';
        const VIEW_COUNT = 'viewCount';
        const DURATION = 'duration';

        const THUMBNAIL_SIZE = window.innerWidth < BREAK_POINT ? 'default' : 'medium';

        api.get('/api/youtube-videos')
          .then((response) => {
            return JSON.parse(response.data);
          })
          .then((data) => {
            this.setState({videos: data[ITEMS].map((val: any) => {
              const retVal: IVideo = {
                  videoChannel: val[SNIPPET][CHANNEL_TITLE],
                  videoDuration: val[CONTENT_DETAILS][DURATION],
                  videoId: val[ID],
                  videoThumbnailSrc: val[SNIPPET][THUMB_NAILS][THUMBNAIL_SIZE][URL],
                  videoTitle: val[SNIPPET][TITLE],
                  videoViews: val[STATISTICS][VIEW_COUNT]
              };
              return retVal;
            })});
          });

    }

    public render() {
        return(
            <div className={`VideoFeed-container${window.innerWidth < BREAK_POINT ? '-mobile' : ''}${this.props.className ? ` ${this.props.className}` : ''}`}>
            {this.state.videos.length !== 0 && Array.apply(null, { length: this.props.displayNum }).map(Number.call, Number).map((index: number) => {
                const current = this.state.videos[index];
                if (!current) return null;
                return <VideoFeedItem className={this.props.itemClassName} key={current.videoId} {...current} videoDuration={this.formatVideoDuration(current.videoDuration)} />; // duration passed last to prevent overwrite
            })}
            
            </div>
        );
    }

    private formatVideoDuration(input: string): string {
        const inputSplit = input.split(RegExp('([PTDHMS])'));
        let returnString = '';
        const timeSegments: { [index: string]: string } = {
            hours: '00',
            minutes: '00',
            seconds: '00'
        };

        for (let i: number = 0; i < inputSplit.length; i += 1) {
            switch (inputSplit[i]) {
                case 'D':
                    timeSegments.hours = (24 * Number.parseInt(inputSplit[i - 1])).toString();
                    break;
                case 'H':
                    if (timeSegments.hours !== '00') timeSegments.hours =  (Number.parseInt(inputSplit[i - 1]) + Number.parseInt(timeSegments.hours)).toString();
                    else timeSegments.hours = inputSplit[i - 1];
                    break;
                case 'M':
                    timeSegments.minutes = inputSplit[i - 1];
                    break;
                case 'S':
                    timeSegments.seconds = inputSplit[i - 1];
                    break;
                default:
                    break; // Do nothing
            }
        }

        let largestUnitInserted = false;
        for (const key in timeSegments) {
            if (timeSegments.hasOwnProperty(key)) {
                const val = timeSegments[key];
                if (val === '00' && !largestUnitInserted) continue;

                if (returnString) returnString += ':';
                if (val.length === 1 && largestUnitInserted) returnString += '0';
                returnString += val;
                largestUnitInserted = true;
            }
        }
        return returnString.indexOf(':') !== -1 ? returnString : `0:${returnString}`;
    }
}

export default VideoFeed;



// WEBPACK FOOTER //
// ./src/components/global/application/video/VideoFeed.tsx